import { createContext, useContext } from "react";
import type { Employee } from "@/types/employee";

export interface UserContextValue {
  userRole: string;
  userName: string;
  userEmail: string;
  employeeId: string | null;
  profileId: string | null;
  employee: Employee | null;
  isAdmin: boolean;
  isEmailVerified: boolean;
  isProfileComplete: boolean;
  refreshEmailVerified: () => void;
  refreshProfileComplete: () => void;
  refreshEmployee: () => void;
}

export const UserContext = createContext<UserContextValue>({
  userRole: "trial",
  userName: "使用者",
  userEmail: "",
  employeeId: null,
  profileId: null,
  employee: null,
  isAdmin: false,
  isEmailVerified: false,
  isProfileComplete: true,
  refreshEmailVerified: () => {},
  refreshProfileComplete: () => {},
  refreshEmployee: () => {},
});

export function useUser() {
  return useContext(UserContext);
}